import { Content } from '@volkswagen-onehub/fa-content-service';
import { useFeatureServices } from 'src/feature-app/hooks';

export interface Alias {
  alias: string;
  destino: string;
}
export interface OffersFaContent extends Content {
  carlines?: number[];
  salesgroups?: string[];
  oneform?: number[];
  promocion?: 'cuota-50' | 'gama-mas'
  alias?: Alias[]
  disclaimerType?: 'Footer' | 'Type D6';
  theme: 'main' | 'inverted' | 'image';
  filtroFinanciacion?: "Ninguno" | "My renting" | "My way";
  imageUrl: string;
}

export function useFaContent(): OffersFaContent | undefined {
  return useFeatureServices()['fa-content-service'].content as OffersFaContent;
}

export const useIsType6DisclaimersEnabled = () => useFaContent().disclaimerType === 'Type D6';

